import { useRef, useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import { FloatBox } from "../../../../../core";
import { Filter } from "../../../../../core/icons";

import FiltersItem from "../../../../Common/FiltersItem";

function RoleHeader({ roles = [], onFilter = () => {} }) {
  const containerRef = useRef(null);
  const [show, setShow] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  const updateDimensions = () => setWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const outSideClick = (state) => setShow(state);

  const widthFloatBox = useMemo(() => {
    if (width >= 427 && width <= 949) return 50;
    else if (width >= 950 && width <= 1050) return 75;
    return 100;
  }, [width]);

  return (
    <div
      role="button"
      ref={containerRef}
      onClick={() => setShow(!show)}
      id="students-status-filter-button"
      className="flex flex-row items-center justify-center"
    >
      <div className="relative">
        &nbsp;
        <FloatBox
          open={show}
          width={widthFloatBox}
          containerRef={containerRef}
          handleOnClickOutside={outSideClick}
          className="
            p-4
            mt-2
            bg-white
            border-black
          "
        >
          <FiltersItem
            filters={roles}
            onSelect={onFilter}
            noItemsLabel="No Roles to Show"
            id="students-groups-filter-item-button"
          />
        </FloatBox>
      </div>
      <div className="mr-2">
        <Filter size={15} />
      </div>
      <span className="text-sm">Role</span>
    </div>
  );
}

RoleHeader.protoTypes = {
  onFilter: PropTypes.func,
  groups: PropTypes.arrayOf(PropTypes.string),
};

export default RoleHeader;
